import { Box, Button, Stack } from '@mui/material';
import { Link as ReactRouterLink } from 'react-router-dom';

import { Text, type api } from 'common';

import { FlowDefinitionStateTag } from '../../../../../Definitions/common/StateTag.tsx';
import { ReactFlowOverviewGraph } from '../../../../Graph/View';
import { FlowKind } from '../../constants.tsx';

export const VISIBLE_SUBFLOW_FLOW_KINDS = new Set<FlowKind>([FlowKind.Base, FlowKind.FlowTemplate]);

interface SubFlowContentProps {
  flowDefinition: api.FlowDefinition.SubflowDefinitionWithFlow;
}
export function SubFlowContent(props: SubFlowContentProps) {
  const { flowDefinition } = props;

  return (
    <Stack spacing={2}>
      <Text variant="heading5" bold>
        Flow Details
      </Text>
      <Stack direction="row" gap={1} justifyContent="space-between" width="100%">
        <Text variant="heading5">{`${flowDefinition.name} (v${flowDefinition.version})`}</Text>
        <span>
          <FlowDefinitionStateTag state={flowDefinition.state} />
        </span>
      </Stack>
      {flowDefinition.description && (
        <Text whiteSpace="pre-wrap">{flowDefinition.description}</Text>
      )}
      <Box sx={{ width: '100%', height: 240 }}>
        <ReactFlowOverviewGraph
          flowDefinitionData={flowDefinition.data}
          flowDefinitionOverlayProps={{ version: flowDefinition.version }}
        />
      </Box>
      <Button
        variant="contained"
        component={ReactRouterLink}
        to={`../../../flows/${flowDefinition.flowId}/definitions/${flowDefinition.id}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Open Sub Flow In New Tab
      </Button>
    </Stack>
  );
}
